// extracted by mini-css-extract-plugin
export default {"select":"Selector_select__qBpMs"};